"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = exports.Default = exports.Case = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "condition", "as"];
var Switch = exports.Switch = function Switch(_ref) {
  var _ref2;
  var children = _ref.children;
  var matchChild = null;
  var defaultCase = null;
  var childs = Array.isArray(children) ? children : [children];
  childs.some(function (child) {
    if (!defaultCase && child && child.type === Default) {
      defaultCase = child;
    }
    if (child && child.type === Case) {
      var condition = child.props.condition;
      var conditionIsTrue = Boolean(condition);
      if (conditionIsTrue) {
        matchChild = child;
        return true;
      }
    }
    return false;
  });
  return (_ref2 = matchChild !== null && matchChild !== void 0 ? matchChild : defaultCase) !== null && _ref2 !== void 0 ? _ref2 : null;
};
var Case = exports.Case = function Case(props) {
  var children = props.children,
    condition = props.condition,
    Comp = props.as,
    reset = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var Elm = Comp;
  return Elm ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Elm, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
    children: children
  })) : children;
};
var Default = exports.Default = function Default(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Case, (0, _objectSpread2["default"])({}, (0, _objectSpread2["default"])({}, props)));
};